import Box from './Box'
import React from 'react'

const News = ({
    modalTitle,
    generateHeaderCloseIco,
    newsList,
    setType,
    setCurrSingleNews,
    getNews,
    currUser,
    socket,
    handleSetIsEditing,
    userSuspended
}) => {

    const handleAddNewsClick = () => {
        setType('addnews')
    }

    const renderNews = () => {
        return newsList.map((news) => {
            return <div key={`${Math.random()}`} className="margin-right margin-left-10">
                <Box handleSetIsEditing={handleSetIsEditing} socket={socket} currUser={currUser} getNews={getNews} setCurrSingleNews={setCurrSingleNews} setType={setType} isInModal={true} key={`${Math.random()}${newsList.length}`} news={news} showBtn={true} />
            </div>
        })

    }

    return (
        <div className="pop-up">
            <div className="pop-up-content">
                <div className="pop-up__title border-none">
                    <div className="pop-up__title__content">
                        {modalTitle}
                        {generateHeaderCloseIco()}
                        <div className="controls-titlebar border-top">
                        <button disabled={userSuspended} onClick={handleAddNewsClick} className="content-button margin-top margin-bottom">Dodaj novu temu/vijest +</button>
                        </div>
                    </div>
                </div>
                <div className="modal-content-wrapper">
                    {renderNews()}
                </div>

            </div>
        </div>
    )
}

export default News